import React, { useCallback, useState, useEffect } from "react";
import CustomButton from "../../../../atoms/CustomButton";
import Download from "../../../../icons/Import";
import Filter from "../../../../icons/Filter";
import { v4 as uuidv4 } from "uuid";
import CustomDataGrid from "../../../../organisms/CustomDatagrid";
import Form from "./Form";
import { deleteData, getData } from "../../../../../services";
import Modal from "../../../../organisms/modals/Modal";
import { useCookies } from "react-cookie";
import moment from "moment/moment";
import Search from "../../../../molecules/search";
import Pagination from "../../../../molecules/Pagination";
import VerticalMenu from "../../../../icons/VerticalMenu";
import CustomMenu from "../../../../atoms/CustomMenu";
import View from "../../../../icons/View";
import Edit from "../../../../icons/Edit";
import Delete from "../../../../icons/Delete";
import DeleteModal from "../../../../organisms/modals/DeleteModal";
import Import from "../../../../molecules/Import";
import NoContentCard from "../../../../atoms/NoContentCard";
import NoContentIcon from "../../../../icons/NocontentIcon";
import toast from "react-hot-toast";
import {
  errorStyles,
  confimationStyles,
} from "../../../../../assets/styles/toast";
import { useSelector } from "react-redux";
import BusinessSegmentForm from "./Form";

const BusinessSegment = () => {
  const [cookies] = useCookies([]);
  const [tableData, setTableData] = useState([]);
  const [selectedRow, setSelectedRow] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchedValue, setSearchedValue] = useState();
  const [isImportActive, setIsImportActive] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [modalState, setModalState] = useState({
    isModalOpen: false,
    modalData: null,
    isDeleteModalOpen: false,
    modalId: "",
    name: "",
  });

  

  const accessData = useSelector((state) => state.accessDetails?.accessData);
  const isAdmin = accessData?.role?.label === "Admin";


  const businessSegmentAccess =
    accessData?.access?.find(
      (module) => module.module === "Business Segment"
    ) || {};

  // Determine if user can edit or delete
  const canEdit = isAdmin || businessSegmentAccess?.is_edit;
  const canDelete = isAdmin || businessSegmentAccess?.is_delete;

  const showMenu = canEdit || canDelete;

  const getUserData = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await getData({
        endpoint: "BusinessSegment/getAllBusinessSegment",
        params: {
          searchQuery: searchedValue,
          page: currentPage,
          page_limit: itemsPerPage,
          // business_id: cookies.bid,
        },

        token: cookies.e_t,
      });
      if (res) {
        const newRes = res?.data;
        const dataWithSNo = newRes?.business_segment_data.map((item, index) => ({
          ...item,
          sno: (currentPage - 1) * itemsPerPage + index + 1,
        }));
        setTableData({...newRes, business_segment_data: dataWithSNo });
      }
    } catch (error) {
      console.error(error); // Use console.error for errors
    } finally {
      setIsLoading(false);
    }
  }, [cookies.e_t, currentPage, itemsPerPage, searchedValue]);

  useEffect(() => {
    getUserData();
  }, [getUserData]);

  const menu = [
    canEdit && {
      icon: <Edit height="20" width="20" />,
      label: "Edit",
      onClick: () => {
        setAnchorEl(null);
        handleEdit(selectedRow);
      },
    },
    canDelete && {
      icon: <Delete />,
      label: "Delete",
      onClick: () => {
        setAnchorEl(null);
        handleDeleteModal(selectedRow);
      },
    },
  ].filter(Boolean);

  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      flex: 0.6,
      sortable: true,
    },

    {
      field: "name",
      headerName: "Business Segment",
      flex: 1,
      sortable: true,
    },
    {
      field: "created_at",
      headerName: "Added On",
      flex: 1,
      renderCell: (params) => {
        return (
          <span>
            {params?.row?.created_at &&
              moment(params.row.created_at).format("DD/MM/YYYY")}
          </span>
        );
      },
      sortable: true,
    },
    {
      field: "actions",
      headerName: "",
      flex: 0.2,
      renderCell: (params) => {
        if (!showMenu) return null;
        return (
          <div className="table-icons-container">
            <div onClick={(event) => handleStatusMenu(event, params.row)}>
              <VerticalMenu />
            </div>

            <CustomMenu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              items={menu}
            />
          </div>
        );
      },
    },
  ];

  const handleDeleteModal = (data) => {
    setModalState((prevState) => ({
      ...prevState,
      isDeleteModalOpen: true,
      modalId: data.id,
      name: data.name,
      email: data.email,
    }));
  };

  const handleStatusMenu = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleEdit = (tableData) => {
    setModalState((prevState) => ({
      ...prevState,
      modalId: tableData.id,
      modalData: tableData,
      isModalOpen: true,
      title: "Edit Business Segment",
    }));
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const handleItemsPerPageChange = useCallback((perPage) => {
    setCurrentPage(1);
    setItemsPerPage(perPage);
  }, []);

  const handleDeletion = async () => {
    try {
      const res = await deleteData({
        endpoint: "BusinessSegment/deleteBusinessSegmentById",
        params: {
          id: modalState.modalId,
        },
      });
      if (res?.data?.status === false) {
        toast.error(res?.data?.message, {
          style: errorStyles,
          duration: 1000,
        });
      } else {
        toast.success("Business Segment Deleted Sucessfully", {
          style: confimationStyles,
          duration: 1000,
        });
        getUserData();
      }
    } catch (error) {
      toast.error("An Error Occured While Deleting", {
        style: errorStyles,
        duration: 1000,
      });
      console.log(error);
    } finally {
      setModalState((prevState) => ({
        ...prevState,
        isDeleteModalOpen: false,
      }));
    }
  };

  const openModal = (title, data) => {
    const modalId = uuidv4();
    setModalState((prevState) => ({
      ...prevState,
      modalId,
      isModalOpen: true,
      title,
      modalData: data,
    }));
  };

  const closeModal = () => {
    // if(type === 'submitted'){
    setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
    // } else {
    //   // setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
    //   setIsFormDirty(true)
    //   setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
    // }
  };

  const CustomNoRowsOverlay = React.memo(() => {
    return (
      <>
        {/* {!!searchedValue ? (
          <NoContentCard
            title="No Record Found"
            type="Company"
            icon={<NoContentIcon />}
            small={true}
          />
        ) : ( */}
        <NoContentCard
          title="No Business Segment Found"
          type="Employee"
        />
      </>
    );
  });

  return (
    <>
        <div className="d-flex justify-content-between">
        <h3 className="h2-j semi-light mb-0">Business Segment</h3>
        <div className="d-flex gap-2">
            <Search
              placeholder="Search"
              onSearchEmit={(item) => {
                if (currentPage !== 1) {
                  setCurrentPage(1);
                }
                setSearchedValue(item);
              }}
            />
            {canEdit && (
            <CustomButton
              text="Add Business Segment"
              handleClick={() => openModal("Add Business Segment")}
              type="btn-outline-primary"
            />
          )}
          </div>
        </div>

        
        <div className="mt-3">
          <CustomDataGrid
            columns={columns}
            CustomNoRowsOverlay={CustomNoRowsOverlay}
            rows={tableData?.business_segment_data|| []}
            isLoadingStateProvided={true}
            isLoading={isLoading}
            onCellClick={(params) => {
              if (params.field !== "actions" && canEdit) {
                handleEdit(params.row);
              }
            }}
            canEdit={canEdit}
          />
        </div>

        {tableData?.total_records > 10 && (
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={tableData?.total_records}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
        )}

        {isImportActive && (
          <Import
            isActive={isImportActive}
            onClose={() => {
              setIsImportActive(false);
              getUserData();
            }}
          />
        )}

        {modalState?.isModalOpen && (
          <Modal
            id={modalState?.modalId}
            title={modalState.title}
            isActive={modalState?.isModalOpen}
            onClose={closeModal}
            takeConfirmation={isFormDirty ? true : false}
            width="650px"
          >
            <BusinessSegmentForm
              onFormDirty={setIsFormDirty}
              refetchData={getUserData}
              initialData={
                modalState.title === "Edit Business Segment" ? modalState.modalData : null
              }
              onClose={() => closeModal("submit")}
            />
          </Modal>
        )}

        {modalState.isDeleteModalOpen && (
          <DeleteModal
            name={modalState.name}
            id={modalState.modalId}
            isActive={modalState.isDeleteModalOpen}
            onClose={() =>
              setModalState((prevState) => ({
                ...prevState,
                isDeleteModalOpen: false,
              }))
            }
            title="Business Segment"
            onClick={handleDeletion}
          />
        )}
     
    </>
  );
};

export default BusinessSegment;
